import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import {
  ApiResponse,
  PresetCategoriesListResponse,
  PresetCategoryDetail,
  CreatePresetCategoryRequest,
  UpdatePresetCategoryRequest,
} from '../models/preset-categories.models';

@Injectable({
  providedIn: 'root',
})
export class PresetCategoriesApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/preset-categories`;

  getCategories(
    pageNumber: number = 1,
    pageSize: number = 20,
    search?: string,
    isActive?: boolean,
  ): Observable<ApiResponse<PresetCategoriesListResponse>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (search) {
      params = params.set('search', search);
    }

    if (isActive !== undefined && isActive !== null) {
      params = params.set('isActive', isActive.toString());
    }

    return this.http.get<ApiResponse<PresetCategoriesListResponse>>(this.baseUrl, { params });
  }

  getCategory(id: number): Observable<ApiResponse<PresetCategoryDetail>> {
    return this.http.get<ApiResponse<PresetCategoryDetail>>(`${this.baseUrl}/${id}`);
  }

  createCategory(payload: CreatePresetCategoryRequest): Observable<ApiResponse<PresetCategoryDetail>> {
    return this.http.post<ApiResponse<PresetCategoryDetail>>(this.baseUrl, payload);
  }

  updateCategory(id: number, payload: UpdatePresetCategoryRequest): Observable<ApiResponse<PresetCategoryDetail>> {
    return this.http.put<ApiResponse<PresetCategoryDetail>>(`${this.baseUrl}/${id}`, payload);
  }

  deleteCategory(id: number): Observable<ApiResponse<string>> {
    return this.http.delete<ApiResponse<string>>(`${this.baseUrl}/${id}`);
  }
}
